<div class="flex h-screen overflow-hidden">

  <!-- Sidebar -->
  <aside class="flex flex-col shrink-0 bg-[#293f54] text-white transition-all duration-200 overflow-hidden"
         [style.width]="isCollapsed ? '56px' : '195px'">

    <div class="flex items-center justify-center py-4 px-2 min-h-[100px]">
      @if (!isCollapsed) {
        <img src="assets/images/logo-mua-white.png" alt="Logo" class="h-[100px] object-contain">
      }
    </div>

    <nav class="flex-1 flex flex-col gap-2 px-2 pt-2">
      @for (section of visibleSections(); track $index) {
        <a routerLinkActive="sidebar-active" [routerLink]="section.route"
           class="sidebar-item flex items-center gap-2 px-3 py-2 rounded cursor-pointer"
           [title]="section.name | translate">
          <span class="material-icons-outlined text-[19px] shrink-0">{{ section.icon }}</span>
          @if (!isCollapsed) {
            <span class="text-sm truncate">{{ section.name | translate }}</span>
          }
        </a>
      }
      <a class="sidebar-item flex items-center gap-2 px-3 py-2 rounded cursor-pointer"
         (click)="onBlankPageClick()" [title]="'lOGIN_MUA' | translate">
        <span class="material-icons-outlined text-[19px] shrink-0">login</span>
        @if (!isCollapsed) {
          <span class="text-sm truncate">{{ 'lOGIN_MUA' | translate }}</span>
        }
      </a>
    </nav>

    @if (!isCollapsed) {
      <div class="px-4 py-3 text-xs opacity-50">{{ version }}</div>
    }
  </aside>

  <!-- Main content -->
  <div class="flex flex-col flex-1 min-w-0 overflow-hidden">
    <app-toolbar (toggleSidenav)="onToggleSidenav()"></app-toolbar>
    <main #mainContent class="flex-1 overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </div>

</div>

@if (isScrollTopVisible$ | async) {
  <app-scroll-to-top (scrollToTopEvent)="handleScrollToTop()"></app-scroll-to-top>
}

<app-export-toast />
